import {
  Box,
  FormControl,
  FormControlLabel,
  Grid2,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import CloseModalIcon from "../icons/CloseModalIcon";
import CustomButton from "../common/CustomButton";
import TransferPayment from "./TransferPayment";
import WalletPayment from "./WalletPayment";
import ModalPaymentSuccess from "./ModalPaymentSuccess";
import { RootContext } from "../layout";
import { getFormattedDateTime, RandomOrderId } from "../../Utils/helper";
import UndoIcon from "../icons/UndoIcon";
import ProductCartItem from "../product/ProductCartItem";

const root = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%", // 90% width on extra small screens
    sm: "80%", // 80% width on small screens
    md: "55%", // 60% width on medium screens
    lg: "50%", // 40% width on large screens
  },
  height: {
    xs: "95%", // 90% width on extra small screens
    sm: "80%", // 80% width on small screens
  },
  bgcolor: "#15141B",
  color: "white",
  border: "none",
  boxShadow: 24,
  p: 4,
};

const iconContainer = {
  position: "absolute",
  cursor: "pointer",
  right: { xs: 30, sm: 16 },
  top: { xs: 30, sm: 16 },
  backgroundColor: "transparent",
};
const backContainer = {
  position: "absolute",
  cursor: "pointer",
  left: { xs: 30, sm: 16 },
  top: { xs: 30, sm: 16 },
  backgroundColor: "transparent",
};

const icon = {
  height: { xs: "12px" },
  width: { xs: "12px" },
};

const Banks = [
  {
    bank: "bidv",
    bank_name: "BIDV",
    account_no: "963012000515736",
    account_name: "ARTISM",
  },
  {
    bank: "bidv",
    bank_name: "BIDV",
    account_no: "963012000520967",
    account_name: "ARTISM",
  },
  {
    bank: "msb",
    bank_name: "MSB",
    account_no: "9686687660000390147",
    account_name: "ARTISM",
  },
];

export default function ModalPayment({
  resetData = () => {},
  open = false,
  handleClose = () => {},
  data,
}) {
  const { price } = data;
  const [select, setSelect] = useState(false);
  const [method, setMethod] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const { balances, setBalances } = useContext(RootContext);
  const [loading, setLoading] = useState(true);
  const [loadingConfirmPayment, setLoadingConfirmPayment] = useState(false);
  const [selectedbank, setSelectedBank] = useState(
    Banks[Math.floor(Math.random() * Banks.length)]
  );
  const [orderId, setOrderId] = useState(RandomOrderId());

  const handleConfirmPayment = () => {
    setLoadingConfirmPayment(true);
    setTimeout(() => {
      handleClose();
      setOpenSuccess(true);
      if (method !== "bank") {
        setBalances([
          {
            id: "06c1774-7f3d-46ad...90a8",
            type: "withdraw",
            amount: price,
            balance: balances[0].balance - Number(price),
            date: getFormattedDateTime(),
          },
          ...balances,
        ]);
      }
      setLoadingConfirmPayment(false);
      setLoading(true);
      setSelect(false);
    }, 2000);
  };

  const handleRadioChange = (event) => {
    setSelectedBank(Banks[Math.floor(Math.random() * Banks.length)]);
    setSelect(true);
    setLoading(true);
    setMethod(event.target.value);
    if (event.target.value === "wallet") {
      setTimeout(() => {
        if (event.target.value === "wallet") {
          setLoading(false);
        }
      }, 1000);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={root}
          onClick={() => {
            handleClose();
            setLoading(true);
            setMethod("");
            setSelect(false);
          }}
        >
          <Box sx={iconContainer}>
            <CloseModalIcon sx={icon} />
          </Box>
          {select && (
            <Box
              onClick={(event) => {
                event.stopPropagation();
                setSelect(false);
                setMethod("");
              }}
              sx={backContainer}
            >
              <UndoIcon style={{ width: "20px", height: "20px" }} />
            </Box>
          )}

          <Box
            onClick={(event) => event.stopPropagation()}
            id="modal-modal-description"
            sx={{
              p: 3,
              overflowX: "auto",
              height: "90%",
              overFlowX: "auto",
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari, and Edge
              },
            }}
          >
            {!select ? (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                marginTop={2}
              >
                <Box>
                  <ProductCartItem data={data} />
                </Box>
                <Typography variant="h6" mt={2}>
                  Payment Methods
                </Typography>
                <Box display="flex" flexDirection="column" marginTop={2}>
                  <FormControl>
                    <RadioGroup
                      value={method}
                      onChange={handleRadioChange}
                      name="radio-buttons-group"
                      sx={{
                        display: "flex",
                        gap: 2,
                      }}
                    >
                      <FormControlLabel
                        value="bank"
                        sx={{
                          border: "1px solid rgba(193, 192, 229, 0.08)",
                          borderRadius: "12px",
                          height: "40px",
                          backgroundColor: "#191922",
                        }}
                        control={<Radio icon={<></>} checkedIcon={<></>} />}
                        label="Bank Transfer"
                      />
                      <FormControlLabel
                        value="wallet"
                        sx={{
                          border: "1px solid rgba(193, 192, 229, 0.08)",
                          borderRadius: "12px",
                          height: "40px",
                          backgroundColor: "#191922",
                        }}
                        control={<Radio icon={<></>} checkedIcon={<></>} />}
                        label="Your Wallet"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            ) : (
              <Grid2 container spacing={3}>
                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      textAlign: { xs: "center", sm: "left", md: "left" },
                    }}
                  >
                    Payment
                  </Typography>
                  <Box>
                    <ProductCartItem data={data} />
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                  <Box marginBottom={2}>
                    {method === "bank" ? (
                      <TransferPayment
                        selectedbank={selectedbank}
                        amount={price}
                        loading={loading}
                        setLoading={setLoading}
                        orderId={orderId}
                      />
                    ) : (
                      <WalletPayment amount={price} loading={loading} />
                    )}
                  </Box>
                  <CustomButton
                    loading={loadingConfirmPayment}
                    disabled={loadingConfirmPayment || loading}
                    handleClick={handleConfirmPayment}
                  >
                    Confirm
                  </CustomButton>
                </Grid2>
              </Grid2>
            )}
          </Box>
        </Box>
      </Modal>
      <ModalPaymentSuccess
        data={data}
        orderId={orderId}
        open={openSuccess}
        handleClose={() => {
          setOpenSuccess(false);
          resetData();
          setMethod("");
        }}
      />
    </div>
  );
}
